<div class="domain-badge-container" [ngStyle]="{'justify-content': justifyContent, 'gap': gap}">
  <ng-container *ngFor="let domain of domains">
    <div class="domain-badge {{domain.shortName?.toLowerCase()}}" [ngStyle]="{'font-size': fontSize}">{{getShortName(domain).toUpperCase()}}</div>
  </ng-container>
</div>
